<a
  [href]="href()"
  [attr.aria-disabled]="disabled()"
  [tabindex]="disabled() ? -1 : 0"
  (click)="onClick($event)"
  [class]="classes()"
  [class.mobile]="isMobile()"
>
  @if (svgIcon()) {
    @if (primary()) {
      <nz-icon [nzType]="svgIcon()" class="svg-icon fillwhite" />
    } @else if (!primary() && darksecondary()) {
      <nz-icon [nzType]="svgIcon()" class="svg-icon" />
    } @else {
      <nz-icon [nzType]="svgIcon()" class="svg-icon" />
    }
  }
  <span class="projected-content">
    <ng-content></ng-content>
  </span>
  <!-- Project content inside the button -->
  @if (svgIconRight() !== "") {
    <nz-icon
      class="icon icon-right fillwhite"
      [nzType]="svgIconRight()"
      nzTheme="outline"
    />
  }
</a>
